<!-- Only render if open -->
@if (isOpen) {
<div class="fixed inset-0 flex items-start justify-center overflow-y-auto modal py-10 z-modal">
  <!-- Backdrop -->
  @if (!isFullscreen) {
  <div class="fixed inset-0 h-full w-full  backdrop-blur-sm" (click)="onBackdropClick($event)"></div>
  }
  <!-- Modal Content -->
  <div [ngClass]="isFullscreen ? 'w-full h-full' : 'relative w-full rounded-3xl bg-white dark:bg-gray-900 max-h-[calc(100vh-5rem)] overflow-y-auto custom-scrollbar'"
    [class]="className" (click)="onContentClick($event)">
    <div>
      <ng-content></ng-content>
    </div>
  </div>
</div>
<!-- Close button: HERMANO del wrapper (no hijo), su z-index no queda atrapado en el stacking context del modal -->
@if (showCloseButton) {
<button (click)="close.emit()" aria-label="Cerrar"
  class="z-modal-close fixed right-4 top-4 flex h-10 w-10 items-center justify-center rounded-full bg-white/90 text-gray-600 shadow-lg ring-1 ring-black/5 backdrop-blur transition-colors hover:bg-white hover:text-gray-900 dark:bg-gray-800/90 dark:text-gray-300 dark:ring-white/10 dark:hover:bg-gray-800 dark:hover:text-white sm:right-6 sm:top-6 sm:h-11 sm:w-11">
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd"
      d="M6.04289 16.5413C5.65237 16.9318 5.65237 17.565 6.04289 17.9555C6.43342 18.346 7.06658 18.346 7.45711 17.9555L11.9987 13.4139L16.5408 17.956C16.9313 18.3466 17.5645 18.3466 17.955 17.956C18.3455 17.5655 18.3455 16.9323 17.955 16.5418L13.4129 11.9997L17.955 7.4576C18.3455 7.06707 18.3455 6.43391 17.955 6.04338C17.5645 5.65286 16.9313 5.65286 16.5408 6.04338L11.9987 10.5855L7.45711 6.0439C7.06658 5.65338 6.43342 5.65338 6.04289 6.0439C5.65237 6.43442 5.65237 7.06759 6.04289 7.45811L10.5845 11.9997L6.04289 16.5413Z"
      fill="currentColor" />
  </svg>
</button>
}
}
